import React, { useEffect } from 'react'

import { Icon, useMediaQueryContext } from '@fourthwall/components'
import { SearchIcon } from '@fourthwall/icons'

import { useAIKitDashboard } from '../AIKitDashboardProvider'
import * as S from './OmnisearchToolbarButton.styled'

export const OmnisearchToolbarButton: React.FC = () => {
  const { openOmnisearch, isOmnisearchEnabled } = useAIKitDashboard()
  const media = useMediaQueryContext()

  const platform = navigator.platform?.toLowerCase() || ''
  const isMacOS = /mac/.test(platform)

  useEffect(() => {
    if (!isOmnisearchEnabled) return

    const handleKeyDown = (e: KeyboardEvent) => {
      // Global keyboard shortcut: Cmd+K / Ctrl+K
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault()
        openOmnisearch()
      }
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [isOmnisearchEnabled, openOmnisearch])

  if (!isOmnisearchEnabled) {
    return null
  }

  if (!media.laptop) {
    return null
  }

  return (
    <S.ButtonWrapper onClick={openOmnisearch}>
      <S.ContentWrapper>
        <S.SearchIconWrapper>
          <Icon component={SearchIcon} width={16} height={16} />
        </S.SearchIconWrapper>
        <S.PlaceholderText>Search or ask anything...</S.PlaceholderText>
      </S.ContentWrapper>
      <S.KeyboardBadgeWrapper>
        {isMacOS ? <S.Key size="large">⌘</S.Key> : <S.Key>Ctrl</S.Key>}
        <S.Key>K</S.Key>
      </S.KeyboardBadgeWrapper>
    </S.ButtonWrapper>
  )
}
